export class PlanState {
    constructor(expiredPlans, activePlans) {
        this.expiredPlans = expiredPlans ?? [];
        this.activePlans = activePlans ?? [];
    }
    /**
     * Gets the expired plan state.
     */
    hasExpiredPlan() {
        return this.expiredPlans.length > 0;
    }
    /**
     * Gets the active plan state.
     */
    hasActivePlan() {
        return this.activePlans.length > 0;
    }
}
